<template>
  <div class="el_card">
    <div v-if="!small" class="el_card_title">
      {{ title }}
    </div>
    <div v-else class="el_card_title_small">
      {{ title }}
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'MaterialCard',
  props: {
    title: {
      type: String,
      default: false,
    },
    small: {
      type: Boolean,
    },
  },
}
</script>

<style scoped>
.el_card {
  width: 735px;
  height: 742px;

  background: #ffffff;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
  border-radius: 44px;
}

.el_card_title {
  text-align: left;
  height: 75px;
  padding-top: 40px;
  padding-left: 63px;

  font-family: Noto Sans JP;
  font-style: normal;
  font-weight: normal;
  font-size: 51.2972px;
  line-height: 74px;
  /* identical to box height */

  color: #6b6b6b;
}

.el_card_title_small {
  text-align: left;
  height: 75px;
  padding-top: 20px;
  padding-left: 63px;

  font-family: Noto Sans JP;
  font-style: normal;
  font-weight: normal;
  font-size: 34px;
  line-height: 74px;
  /* identical to box height */

  color: #6b6b6b;
}
</style>
